import { recentOrdersStyles as styles } from "@insite/content-library/Widgets/Common/RecentOrders";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const cardContainerCommonStyles = css`
    border: 0;
    border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
    padding: 16px 0;

    &:last-child {
        border: 0;
    }

    ${mediaQueriesBP.minMD} {
        padding: 24px 0;
    }
`;

export const cardSummaryCommonStyles = css`
    padding: 0;
`;

export const cardNoItemsCommonStyles = css`
    padding: 16px 0;

    ${mediaQueriesBP.minMD} {
        padding: 24px 0;
    }
`;

styles.cardContainer = {
    ...styles.cardContainer,
    cardDivider: {
        css: css`
            ${styles.cardContainer?.cardDivider?.css};
            ${cardContainerCommonStyles}
        `,
    },
};

styles.orderSummaryCard = {
    ...styles.orderSummaryCard,
    orderSummaryCardGridItem: {
        ...styles.orderSummaryCard?.orderSummaryCardGridItem,
        css: css`
            ${styles.orderSummaryCard?.orderSummaryCardGridItem?.css};
            ${cardSummaryCommonStyles}
        `,
    },
};

styles.noOrdersFoundGridItem = {
    ...styles.noOrdersFoundGridItem,
    css: css`
        ${styles.noOrdersFoundGridItem?.css};
        ${cardNoItemsCommonStyles}
    `,
};
